var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0, 0, 0, 0.5)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M4 8h24M4 16h24M4 24h24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeline);
export default __webpack_public_path__ + "static/media/threeline.08efe1737029cb6651c0a1c377f1a93e.svg";
export { ForwardRef as ReactComponent };